import React from 'react'
import { withPrefix } from "gatsby"

import imageStyles from "./Image.module.css"

export default function Image({ children, src, alt }) {

    return(       
        <div className={imageStyles.container}>

            <img src={withPrefix(`/images/docs/${src}`)} alt={alt} />

        </div>
    )
}